import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import data from "../../config/data.json";
import BlogHeader from "./BlogHeader";
import BlogAuthor from "./BlogAuthor";
import BlogContent from "./BlogContent";
import BlogNavigation from "./BlogNavigation";
import "./blogdetail.css";

const BlogDetail = () => {
  const { blogId } = useParams();
  const navigate = useNavigate();

  const post = data.blogs.find((blog) => blog.id === blogId);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleNavigateToBlogs = () => {
    navigate("/");
    setTimeout(() => {
      const blogSection = document.getElementById("blogs");
      if (blogSection) {
        blogSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  if (!post) {
    return (
      <div className="not-found">
        <h2>Blog Not Found</h2>
        <button className="back-button" onClick={() => navigate("/blog-post")}>
          Back to Blogs
        </button>
      </div>
    );
  }

  return (
    <div id="blog" className="container-fluid blog-white-bg">
      <div className="container-fluid blog-main-section">
        <BlogHeader
          heading={post.heading}
          subHeading={post.sub_heading}
          topImage={post.top_image}
        />

        <BlogNavigation
          onNavigate={handleNavigateToBlogs}
          label="Back"
          className="blog-back-margin"
        />

        <BlogAuthor
          founderImage={post.founder_image}
          founderName={post.founder_name}
          blogId={post.id}
        />

        <BlogContent topics={post.topics} />

        <div className="blog-back click">
          <h5 className="blogger-name click">
            <span className="grey" onClick={handleNavigateToBlogs}>
              Back
            </span>{" "}
            <span className="grey" onClick={() => navigate("/")}>
              Home
            </span>
          </h5>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
